import React from 'react';
import PropTypes from 'prop-types';

export default class ListingPagesInfo extends React.PureComponent {

    render() {
        return (
            <span>
                displaying {this.props.itemsCount} of {this.props.pagination.totalCount}
            </span>
        )
    }
}

ListingPagesInfo.propTypes = {
    itemsCount: PropTypes.number,
    pagination: PropTypes.object.isRequired,
};




// WEBPACK FOOTER //
// ./app/components/listing/js/ListingPagesInfo.js